<template>
  <v-container fluid>
    <v-pagination v-model="currentPage" class="my-4" :length="pages" @input="onCurrentPageChange" />
  </v-container>
</template>

<script>
  export default {
    name: "CategoryPagination",

    data() {
      return {
        pageSize: 9,
      };
    },

    computed: {
      currentPage: {
        get() {
          return this.$store.getters.currentCategoryPaginationInfo.currentPage;
        },
        set(newValue) {
          this.$store.commit("setCategoryPaginationInfo", {
            pageSize: this.pageSize,
            currentPage: newValue,
          });
        },
      },
      pages() {
        let total = this.$store.getters.currentCategoryPaginationInfo.total;
        let pageNumber;

        if (this.$validator.isInteger(total)) {
          if (total === 0) {
            pageNumber = 1;
          } else if (total !== 0 && total % this.pageSize === 0) {
            pageNumber = Math.trunc(total / this.pageSize);
          } else {
            pageNumber = Math.trunc(total / this.pageSize) + 1;
          }
        }

        return pageNumber;
      },
    },

    methods: {
      onCurrentPageChange() {
        this.$store.commit("setCategoryPaginationInfo", {
          pageSize: this.pageSize,
          currentPage: this.currentPage,
        });

        this.$emit("fetch-products");
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Catalog/CategoryPagination.vue